import { createFileRoute } from '@tanstack/react-router'
import { GalpoesPage } from '@/features/galpoes/galpoes-page'

export const Route = createFileRoute('/_authenticated/galpoes')({
  component: GalpoesPage,
})
